import { CheckCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { Button, Flex, Tag } from 'antd';
import { COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
;
const tagColorMap = {
    false: 'red',
    null: 'orange',
    true: 'blue'
};
const tagLabelMap = {
    false: COPY_GENERIC.FORCE_DISABLED,
    null: COPY_GENERIC.UNSET,
    true: COPY_GENERIC.FORCE_ENABLED
};
function getNameColumn() {
    return {
        dataIndex: 'label',
        key: 'label',
        title: COPY_SPECIFIC.NAME
    };
}
function getStateColumn() {
    return {
        className: 'center-align-cell',
        dataIndex: 'state',
        key: 'state',
        render: (value) => {
            var _a, _b;
            return value !== undefined &&
                React.createElement(Flex, { justify: 'center' },
                    React.createElement(Tag, { color: tagColorMap[(_a = value === null || value === void 0 ? void 0 : value.toString()) !== null && _a !== void 0 ? _a : 'null'] }, tagLabelMap[(_b = value === null || value === void 0 ? void 0 : value.toString()) !== null && _b !== void 0 ? _b : 'null']));
        },
        title: COPY_SPECIFIC.STATE
    };
}
function getEnableByDefaultColumn() {
    return {
        className: 'center-align-cell',
        dataIndex: 'enabledByDefault',
        key: 'enabledByDefault',
        render: (value) => React.createElement(Flex, { "align-items": 'center', justify: 'center' }, Boolean(value) && React.createElement(CheckCircleOutlined, null)),
        title: COPY_SPECIFIC.ENABLE_BY_DEFAULT,
        width: 100
    };
}
function getEnabledCustomersColumn() {
    return {
        className: 'center-align-cell',
        dataIndex: 'count',
        key: 'count',
        render: (value) => React.createElement(Flex, { "align-items": 'center', justify: 'center' }, value),
        title: COPY_SPECIFIC.ENABLED_CUSTOMERS,
        width: 100
    };
}
function getActionColumn(onClick) {
    return {
        dataIndex: '',
        key: 'edit',
        render: (value, record) => React.createElement("div", null, !record.children &&
            React.createElement(Button, { onClick: () => onClick(record.id), type: 'link' }, COPY_SPECIFIC.EDIT))
    };
}
export function getFeatureFlagTableColumns(onClick) {
    return [
        getNameColumn(),
        getStateColumn(),
        getEnableByDefaultColumn(),
        getEnabledCustomersColumn(),
        getActionColumn(onClick)
    ];
}
